import React from 'react';
import Reminder from './Reminder'
import Sidebar from './Sidebar'
import {popupWindow} from './utils/Popup';
import {toggleSidebar, handleModalNoticeOverlay} from './utils/common';
import Cookies from 'universal-cookie';
import ModalNoticeOverlay from "./ModalNoticeOverlay";

class App extends React.Component {

    render() {
        return (
            <div>
                <ModalNoticeOverlay />
                <div id="site-wrapper" onClick={(event) => handleModalNoticeOverlay(event)}>
                    <header className="site-header">
                        <div className="site-header-container">
                            <div className="site-header-row">
                                <div className="header-tagline"><a className="site-logo" href="/index.html"><img
                                    alt="American Immigration"
                                    src="/assets-static/46a4e7b4504d43a0ea7dc32d86ef30a3980854a4/images/logo-en.png"
                                    title="American Immigration"/></a>
                                </div>
                                <div className="m-menu-icon">
                                    <button className="menu-icon" onClick={() => toggleSidebar()}>
                                        <span className="menu-icon-bar"></span>
                                        <span className="menu-icon-bar"></span><span className="menu-icon-bar"></span>
                                        <span className="menu-icon-label">Menu</span>
                                    </button>
                                </div>

                                <div className="user-utility"></div>
                            </div>
                        </div>
                    </header>

                    <nav className="site-nav">
                        <div className="site-nav-container">
                            <div className="site-nav-row">
                                <div className="nav-item"><a href="/index.html">HOME</a></div>
                                <div className="nav-item"><a href="/us-citizenship-and-naturalization-application.html">U.S.
                                    CITIZENSHIP</a>
                                    <div className="menu one-col">
                                        <ul>
                                            <li><a href="/us-citizenship-and-naturalization-application.html">U.S.
                                                Citizenship
                                                Application - <br/><strong>Form N-400</strong></a></li>
                                            <li><a href="/certificate-of-citizenship-N-600.html">Certificate of
                                                Citizenship
                                                -
                                                <br/><strong>Form N-600</strong></a></li>
                                            <li><a href="/replace-certificate-of-citizenship-form-N565.html">Replace
                                                Certificate
                                                of
                                                Citizenship - <strong>Form N-565</strong></a></li>
                                            <li><a
                                                href="/cart/product/us-citizenship-exam-and-interview-guide-dvd-english.html">U.S.
                                                Citizenship Test and Interview DVD</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item"><a href="/cart/category/green-card.html">GREEN CARD</a>
                                    <div className="menu three-cols">
                                        <ul>
                                            <li className="menu-title"><a
                                                href="/replace-lost-stolen-green-card-Form-I-90.html">Green
                                                Card
                                                Renewal and Replacement</a></li>
                                            <li><a href="/replace-lost-stolen-green-card-Form-I-90.html">Green Card
                                                Renewal
                                                -
                                                <br/><strong>Form I-90</strong></a></li>
                                            <li><a href="/replace-lost-stolen-green-card-Form-I-90.html">Green Card
                                                Replacement
                                                -
                                                <br/><strong>Form I-90</strong></a></li>
                                            <li><a href="/lost-stolen-green-card-Form-I-90.html">Lost or Stolen Green
                                                Card <br/><strong>Form
                                                    I-90</strong></a></li>
                                            <li className="menu-title"><a
                                                href="/Get-Green-Card-Through-Family-Member.html">Green
                                                Card
                                                Through Family</a></li>
                                            <li><a href="/Get-Green-Card-Through-Family-Member.html">Get Green Card
                                                through
                                                Family
                                                Member Application</a></li>
                                            <li><a href="/Green-Card-Through-Marriage.html">Get Green Card through
                                                Marriage
                                                Application</a></li>
                                            <li><a href="/Green-Card-For-Your-Parents.html">Green Card for Parent(s)
                                                Application</a>
                                            </li>
                                            <li><a href="/Green-Card-For-Children.html">Green Card for Children
                                                Application</a>
                                            </li>
                                            <li><a href="/Green-Card-For-Brothers-or-Sisters.html">Green Card for
                                                Brothers
                                                or
                                                Sisters
                                                Application</a></li>
                                        </ul>
                                        <ul>
                                            <li className="menu-title"><a
                                                href="/cart/product/green-card-for-domestic-employee-or-unskilled-labor-application.html">Green
                                                Card Through Employment</a></li>
                                            <li><a href="/cart/product/green-card-through-employment-application.html">Green
                                                Card
                                                Through Employment Application</a></li>
                                            <li><a
                                                href="/cart/product/Green-card-for-multinational-executives-and-managers.html">Green
                                                Card for Multinational Executives and Managers</a></li>
                                            <li>
                                                <a href="/cart/product/green-card-for-domestic-employee-or-unskilled-labor-application.html">Green
                                                    Card for Domestic Employee or Unskilled Labor Application</a></li>
                                            <li><a href="/cart/product/immigrant-visa-extraordinary-abilities.html">Immigrant
                                                Visa
                                                Extraordinary Abilities</a></li>
                                            <li><a
                                                href="/cart/product/immigrant-visa-for-outstanding-researchersprofessors.html">Immigrant
                                                Visa for Outstanding Researchers/Professors</a></li>
                                            <li><a href="/cart/product/labor-certification-application.html">Labor
                                                Certification
                                                Application</a></li>
                                            <li><a href="/cart/product/national-interest-waiver.html">National Interest
                                                Waiver</a>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li className="menu-title"><a href="/cart/category/green-card.html">Green
                                                Card -
                                                Related
                                                Forms</a></li>
                                            <li><a href="/greencard/Green-Card-Lottery.html">Green Card Lottery</a></li>
                                            <li><a href="/I-130-immigrant-petition-green-card.html">Immigrant
                                                Petition <br/><strong>Form
                                                    I-130</strong></a></li>
                                            <li><a href="/Adjustment-of-Status-Form-I-485.html">Adjustment of
                                                Status <br/><strong>Form
                                                    I-485</strong></a></li>
                                            <li><a href="/form-i751-remove-conditions-green-card.html">Remove Conditions
                                                on
                                                Green
                                                Card
                                                <strong>Form I-751</strong></a></li>
                                            <li><a href="/form-i751-remove-conditions-green-card.html">Petition to
                                                Remove
                                                the
                                                Conditions
                                                of Residence <br/><strong>Form I-751</strong></a></li>
                                            <li><a href="/cart/product/form-i864-affidavit-of-support.html">Affidavit of
                                                Support
                                                <br/><strong>Form I-864</strong></a></li>
                                            <li><a href="/Form-I-131-Application-Travel-Document.html">Advance Parole
                                                Document
                                                <br/><strong>Form I-131</strong></a></li>
                                            <li><a href="/Form-I-131-Application-Travel-Document.html">Re-entry
                                                Permit <br/><strong>Form
                                                    I-131</strong></a></li>
                                            <li><a href="/cart/product/form-i131-refugee-travel-document.html">Refugee
                                                Travel
                                                Document
                                                <br/><strong>Form I-131</strong></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item"><a href="/cart/category/us-visas.html">U.S. VISAS</a>
                                    <div className="menu two-cols">
                                        <ul>
                                            <li><a href="/cart/product/b1-business-visa-application.html"><strong>B-1
                                                Business
                                                Visa</strong> Application</a></li>
                                            <li><a href="/cart/product/b2-tourist-visa-application.html"><strong>B-2
                                                Tourist
                                                Visa</strong> Application</a></li>
                                            <li><a href="/visa-availability-checker.html"><strong>Visa Availability
                                                Checker</strong></a>
                                            </li>
                                            <li className="menu-title"><a href="/k1-fiancee-visa.html">Visas for Family
                                                Members</a></li>
                                            <li><a href="/cart/product/fiancee-visa.html"><strong>K-1 Fiancé(e)
                                                Visa</strong>
                                                Application</a></li>
                                            <li>
                                                <a href="/cart/product/k3-and-v1v2-us-entry-visa-for-spouse-or-child-application.html"><strong>K-3</strong>
                                                    and <strong>V1/V2</strong> U.S. Entry Visa for Spouse or Child
                                                    Application</a>
                                            </li>
                                            <li className="menu-title"><a href="/cart/product/student-visa.html">Student
                                                Visas</a>
                                            </li>
                                            <li><a href="/cart/product/student-visa.html"><strong>F-1 Student
                                                Visa</strong> Application</a>
                                            </li>
                                            <li><a
                                                href="/cart/product/j1-temporary-exchange-visitor-visa-application.html"><strong>J-1
                                                Temporary Exchange Visitor Visa</strong> Application</a></li>
                                            <li><a href="/cart/product/j1-waiver-application.html"><strong>J-1
                                                Waiver</strong>
                                                Application</a></li>
                                        </ul>
                                        <ul>
                                            <li className="menu-title"><a href="/cart/category/us-visas.html">U.S. Visas
                                                -
                                                Related
                                                Forms</a>
                                            </li>
                                            <li><a href="/greencard/Green-Card-Lottery.html">U.S. Green Card
                                                Lottery <br/><strong>DV-Lottery</strong>
                                            </a></li>
                                            <li><a href="/affidavit-of-support-form-I-134.html">Affidavit of
                                                Support <br/><strong>Form
                                                    I-134</strong></a></li>
                                            <li><a href="/DS-160-nonimmigrant-visa-application.jsp?lang=en">Nonimmigrant
                                                Visa
                                                Application <br/><strong>DS-160 Online</strong></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item"><a href="/cart/category/employment.html">EMPLOYMENT</a>
                                    <div className="menu two-cols">
                                        <ul>
                                            <li className="menu-title"><a
                                                href="/cart/product/green-card-through-employment-application.html">Green
                                                Card
                                                Through Employment</a></li>
                                            <li><a href="/cart/product/green-card-through-employment-application.html">Green
                                                Card
                                                Through Employment Application</a></li>
                                            <li><a
                                                href="/cart/product/Green-card-for-multinational-executives-and-managers.html">Green
                                                Card for Multinational Executives and Managers</a></li>
                                            <li>
                                                <a href="/cart/product/green-card-for-domestic-employee-or-unskilled-labor-application.html">Green
                                                    Card for Domestic Employee or Unskilled Labor Application</a></li>
                                        </ul>
                                        <ul>
                                            <li className="menu-title"><a
                                                href="/cart/product/l1-temporary-work-visa-for-intracompany-transferee-application.html">Temporary
                                                Employment Visas</a></li>
                                            <li><a href="/form-i765-employment-authorization.html">Employment
                                                Authorization
                                                Document
                                                <strong>(EAD)</strong></a></li>
                                            <li><a href="/cart/product/h1b-visa.html"><strong>H-1B</strong> Visa</a>
                                            </li>
                                            <li>
                                                <a href="/cart/product/h2b-work-visa-for-skilled-and-unskilled-workers-application.html"><strong>H-2B</strong>
                                                    Work Visa for Skilled and Unskilled Workers Application</a></li>
                                            <li><a
                                                href="/cart/product/h3-trainee-visa-application.html"><strong>H-3</strong> Trainee
                                                Visa Application</a></li>
                                            <li>
                                                <a href="/cart/product/l1-temporary-work-visa-for-intracompany-transferee-application.html"><strong>L-1</strong>
                                                    Temporary Work Visa for Intracompany Transferee Application</a></li>
                                            <li>
                                                <a href="/cart/product/o1-individuals-of-extraordinary-ability-work-visa-application.html">Individuals
                                                    of Extraordinary Ability Work Visa Application</a></li>
                                            <li><a
                                                href="/cart/product/r1-religious-worker-visa-application.html"><strong>R-1</strong>
                                                Religious Worker Visa Application</a></li>
                                            <li>
                                                <a href="/cart/product/tn-temporary-work-visa-for-citizens-of-canada-and-mexico.html"><strong>TN
                                                    Temporary Work Visa</strong> for Citizens of Canada and Mexico</a>
                                            </li>
                                            <li><a href="/cart/product/investment-visa-application.html"><strong>Investment
                                                Visa</strong> Application</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item menu-right"><a href="/cart/category/immigration-forms.html">IMMIGRATION
                                    FORMS</a>
                                    <div className="menu two-cols">
                                        <ul>
                                            <li><a href="/replace-lost-stolen-green-card-Form-I-90.html">Green Card
                                                Renewal <br/><strong>Form
                                                    I-90</strong></a></li>
                                            <li><a href="/lost-stolen-green-card-Form-I-90.html">Lost or Stolen Green
                                                Card <br/><strong>Form
                                                    I-90</strong></a></li>
                                            <li><a href="/us-citizenship-and-naturalization-application.html">U.S.
                                                Citizenship
                                                Application <br/><strong>Form N-400</strong></a></li>
                                            <li><a href="/DS-160-nonimmigrant-visa-application.jsp?lang=en"> U.S.
                                                Visas <br/><strong>DS-160</strong></a>
                                            </li>
                                            <li><a href="/immigration-forms/form-AR-11.jsp?lang=en">Change of Address
                                                <br/><strong>AR-11</strong></a></li>
                                            <li><a
                                                href="/Form-I-131-Application-Travel-Document.html?referrer=immigrationforms">Application
                                                for Travel Document <br/><strong>Form I-131</strong></a></li>
                                            <li><a
                                                href="/Adjustment-of-Status-Form-I-485.html?referrer=immigrationforms">Adjustment
                                                of
                                                Status <br/><strong>Form I-485</strong></a></li>
                                        </ul>
                                        <ul>
                                            <li><a href="/deferred-action-application-I-821D.html">Deferred Action for
                                                Childhood
                                                Arrivals <strong>Form I-821D (DACA)</strong></a></li>
                                            <li><a href="/form-i751-remove-conditions-green-card.html">Petition to
                                                Remove
                                                Conditions
                                                <br/><strong>Form I-751</strong></a></li>
                                            <li><a
                                                href="/form-i765-employment-authorization.html?referrer=immigrationforms">Employment
                                                Authorization <br/><strong>Form I-765</strong></a></li>
                                            <li><a href="/I-130-immigrant-petition-green-card.html">Immigrant Petition
                                                Family
                                                Green Card
                                                <strong>Form I-130</strong></a></li>
                                            <li><a href="/replace-certificate-of-citizenship-form-N565.html">Replace
                                                Certificate
                                                of
                                                Citizenship <strong>Form N-565</strong></a></li>
                                            <li><a href="/cart/category/immigration-forms.html">More Immigration
                                                Forms</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item menu-right"><a href="/us-immigration-news/">NEWS &amp; INFO</a>
                                    <div className="menu one-col">
                                        <ul>
                                            <li><a href="/us-immigration-news/">US Immigration News</a></li>
                                            <li><a href="/blog/">US Immigration Blog</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item menu-right"><a href="/uscis/us-local-offices.html">USCIS</a>
                                    <div className="menu one-col">
                                        <ul>
                                            <li><a href="/uscis-fee-increase-alert/">USCIS Filing Fee Increase</a></li>
                                            <li><a href="/uscis/us-local-offices.html">USCIS Local Offices</a></li>
                                            <li><a href="/immigration-definition-a.html">Immigration Glossary</a></li>
                                            <li><a href="/case-status/">Case Status</a></li>
                                            <li><a href="/uscis-forms.html">USCIS Forms</a></li>
                                            <li><a href="/green-card-expiration-reminder-service">Green Card Expiration Service</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="nav-item menu-right"><a className="switch-lang"
                                                                        href="/espanol/index.html">ESPAÑOL</a></div>
                            </div>
                        </div>
                    </nav>

                    <div>
                        <Reminder/>
                    </div>

                    <footer className="site-footer">
                        <div className="footer-nav">
                            <a onClick={() => popupWindow('/contact.jsp?lang=en', 800, 600)}>Contact</a>
                            <a onClick={() => popupWindow('/privacy.html', 800, 600)}>Privacy Policy</a>
                            <a onClick={() => popupWindow('/conditions.html', 800, 600)}>Terms of Use </a>
                            <a onClick={() => popupWindow('/conditions.html#refund', 800, 600)}>Refund Policy</a>
                            <a onClick={() => popupWindow('/blog/', 800, 600)}>Blog</a>
                            <a onClick={() => popupWindow('/sitemap.jsp?lang=en', 800, 600)}>Site map</a>
                        </div>
                        <div className="footer-disclaimer">
                            <div className="footer-disclaimer-container">
                                <div className="footer-txt"><p>We are not a law firm, and this site and our software are
                                    not
                                    a
                                    substitute
                                    for the advice of a lawyer and do not contain or constitute legal advice. We are not
                                    affiliated with
                                    or sponsored by the United States government or any government agency. This site
                                    provides
                                    general
                                    information on some commonly encountered immigration matters only and was created to
                                    allow
                                    you to
                                    more simply navigate your completion of immigration paperwork using online software.
                                    The
                                    content on
                                    this site should not be relied on to reach conclusions about any person's specific
                                    situation.
                                    Self-help software and customer support services are provided solely at a user's
                                    direction.
                                    Customer
                                    support is for technical and billing issues only and will not answer legal
                                    questions. We
                                    do
                                    not
                                    provide legal advice, opinions, or recommendations about any individual's specific
                                    legal
                                    rights,
                                    remedies, defenses, options, or strategies. We do not make form recommendations or
                                    recommend
                                    or
                                    provide answers to specific questions on forms, and communications between you and
                                    us
                                    are
                                    not
                                    protected by any privilege. Purchase prices do not include applicable government
                                    agency
                                    filing or
                                    biometrics fees, if any. The forms that can be completed using our software can be
                                    obtained
                                    for free
                                    from the U.S. Citizenship and Immigration Services (USCIS) as blank forms with
                                    written
                                    instructions.
                                    Automated eligibility quizzes were created using instructions, rules and regulations
                                    published by
                                    the USCIS and only indicate whether you meet minimum eligibility requirements to
                                    apply
                                    for
                                    the given
                                    immigration benefit. Quiz results do not guarantee eligibility or ineligibility as
                                    you
                                    may
                                    or may
                                    not be eligible based on reasons not addressed in the quizzes. Your access to and
                                    use of
                                    this site,
                                    including any purchase, is subject to and constitutes your agreement to the website
                                    <a onClick={() => popupWindow('/privacy.html', 800, 600)}>Privacy Policy</a> and
                                    <a onClick={() => popupWindow('/conditions.html', 800, 600)}>Terms of Use</a>.
                                    Refunds
                                    will only be issued if requested within thirty (30) days and before completed
                                    application is
                                    printed. Exceptions and restrictions may apply; see
                                    <a onClick={() => popupWindow('/conditions.html#refund', 800, 600)}>Refund
                                        Policy</a>
                                    for details.</p></div>

                                <div className="footer-copyright"><p>Copyright © 1998-2019. All Rights Reserved.</p>
                                </div>

                            </div>
                        </div>
                    </footer>
                </div>
                <span className="back-to-top"></span>
                <Sidebar/>
            </div>

        );
    }
}


export default App;
